import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form, Field } from 'react-final-form';
import { TextField } from 'final-form-material-ui';
import {
  Grid, Button, MenuItem, Typography, CircularProgress
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import fireBaseApp from '../Firebase';
import { getFirestore, collection, addDoc, } from "firebase/firestore"
import validator from 'validator';
import toast from 'react-hot-toast';
import emailjs from 'emailjs-com';
import { company } from '../data/company';
import { brand } from '../theme';

const db = getFirestore(fireBaseApp);

const useStyles = makeStyles((theme) => ({
  form: {
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(1),
    },
  },
  legend: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${brand.ink}`,
  },
  required: {
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2, 3),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  footnote: {
    color: theme.palette.text.secondary,
    '& a': {
      color: theme.palette.text.primary,
      fontWeight: 600,
      textDecorationColor: brand.accent,
      textUnderlineOffset: '3px',
    },
  },
}));

const onSubmit = async values => {

  try {
    var selectedService = "";
    if (values.service !== undefined) {
      selectedService = values.service;
    }

    var selectedNotes = "";
    if (values.notes !== undefined) {
      selectedNotes = values.notes;
    }

    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      service: selectedService,
      notes: selectedNotes,
    };

    await addDoc(collection(db, "quote_requests"), data);

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      data, process.env.REACT_APP_EMAILJS_USER_ID)
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    toast.success('Thank you! We\'ll talk soon.', { duration: 4000 })
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'Invalid email';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  } else if (!validator.isMobilePhone(values.phone)) {
    errors.phone = 'Invalid phone number';
  }
  return errors;
};

export default function RequestQuoteForm({ services }) {
  const classes = useStyles()

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate className={classes.form}>
          <div className={classes.legend}>
            <Typography variant="h4" component="h3">Request a free quote</Typography>
            <Typography variant="body2" className={classes.required}>* Required</Typography>
          </div>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                required
                name="firstName"
                component={TextField}
                type="text"
                label="First name"
                autoComplete="given-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                required
                name="lastName"
                component={TextField}
                type="text"
                label="Last name"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="email"
                fullWidth
                required
                component={TextField}
                type="email"
                label="Email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="phone"
                fullWidth
                required
                component={TextField}
                type="tel"
                label="Phone"
                autoComplete="tel"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                select
                name="service"
                component={TextField}
                label="Service needed"
              >
                {services.map((value) => (
                  <MenuItem value={value} key={value}>
                    {value}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                name="notes"
                component={TextField}
                multiline
                minRows={3}
                label="Tell us about your project"
              />
            </Grid>
          </Grid>
          <div className={classes.actions}>
            <Button
              size="large"
              variant="contained"
              color="primary"
              type="submit"
              disabled={submitting}
              endIcon={submitting ? <CircularProgress size={18} color="inherit" /> : <ArrowForwardIcon />}
            >
              Send request
            </Button>
            <Typography variant="body2" className={classes.footnote}>
              Or call <a href={company.phoneHref}>{company.phoneDisplay}</a>
            </Typography>
          </div>
        </form>
      )}
    />
  )
}
